
    function syncSidebarHeights() {
        if (window.innerWidth < 1280) return;
        const leftSidebar = document.getElementById('left-sidebar');
        const rightSidebar = document.getElementById('right-sidebar');
        const leftCard = leftSidebar ? leftSidebar.querySelector('.bg-white') : null;
        const rightCard = rightSidebar ? rightSidebar.querySelector('.bg-white') : null;
        if (leftCard && rightCard) {
            rightCard.style.height = leftCard.offsetHeight + 'px';
        }
    }
    window.addEventListener('load', syncSidebarHeights);
    window.addEventListener('resize', syncSidebarHeights);
